// Langues gérées par le module de réservation, dans l'ordre d'affichage.
// Miroir de Lang.SUPPORTED_LANGS côté backend : toute langue ajoutée là-bas doit l'être ici
// (sélecteur de langue du dashboard, traductions des options...).
const LANGUAGES = [
  {code: 'fr', label: 'Français', flag: '🇫🇷'},
  {code: 'en', label: 'English',  flag: '🇬🇧'},
  {code: 'es', label: 'Español',  flag: '🇪🇸'},
  {code: 'it', label: 'Italiano', flag: '🇮🇹'},
  {code: 'de', label: 'Deutsch',  flag: '🇩🇪'},
  {code: 'pl', label: 'Polski',   flag: '🇵🇱'},
];

export const findLanguage = (code) => LANGUAGES.find(l => l.code === code) || LANGUAGES[0];

export default LANGUAGES;
